<header>
  <div class="header-modal-title">
    <i [class]="icon" *ngIf="icon" [ngStyle]="{ color: iconColor }"></i>
    <span [ngStyle]="{ color: titleColor }">{{titleText}}</span>
  </div>
  <a type="button" (click)="close()">
    <i class="fg fg-vuesaxlinearEssetionalclose-circle"></i>
  </a>
</header>
<mat-dialog-content class="mat-typography">
  <p class="text">{{text}}</p>
</mat-dialog-content>
<mat-dialog-actions class="pb-3 d-flex float-right mat-dialog-actions">
  <a type="button" class="cancel-button-color button-simple-dialog" (click)="close()">{{cancelButtonText}}</a>
  <a type="button" class="confirm-button-color button-simple-dialog" (click)="confirm()">{{confirmButtonText}}</a>
</mat-dialog-actions>
